import { Button } from "@bamboohr/fabric"
import { ReactElement } from "react"

export const ApplyButton = ({ onClick, fullWidth } : { onClick: () => void, fullWidth: boolean }): ReactElement => {
    return (
        <Button color="primary" onClick={onClick} size="biggie" type="button" variant="contained" width={fullWidth ? 100 : null}>
            {($.__('Apply for This Job'))}
        </Button>
    )
}